import React from "react";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputField from "../../form/InputField";
import FileUpload from "../../form/FileUpload";

export interface StoreBrandFormData {
  languages: {
    languageCode: string;
    title: string;
  }[];
}

interface Props {
  register: UseFormRegister<StoreBrandFormData>;
  errors: FieldErrors<StoreBrandFormData>;
  cover: File | null ,
  setCover: React.Dispatch<React.SetStateAction<File | null>>
}

const StoreTypeForm: React.FC<Props> = ({ register, errors ,cover,setCover}) => {
  const { t } = useTranslation();

  return (
    <>
    <div className="grid sm:grid-cols-2 gap-4">
      {/* English Brand Name */}
      <InputField
        placeholder=""
        label={t("title_en")}
        register={register("languages.0.title", {
          required: t("required_field"),
        })}
        error={errors.languages?.[0]?.title}
      />

      {/* Arabic Brand Name */}
      <InputField
        placeholder=""
        label={t("title_ar")}
        register={register("languages.1.title", {
          required: t("required_field"),
        })}
        error={errors.languages?.[1]?.title}
      />
    </div>
    <div className=" mt-2">
        <FileUpload
        file={cover}
        setFile={setCover}
        label={t("")}
        addText={t("add_logo")}
        shape="circle"
        size={128}
    />
     </div>
    </>
  );
};

export default StoreTypeForm;
